<template>
    <div>
        <CCol sm="12">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
    
                <CCard class="p-2" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12" md="4" lg="2" class="text-left p-2" v-for="button in buttons" :key="button.value">
                            <div :class="{'blue-background': activeButton === button.value, 'blue-text': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                                <img :src="activeButton === button.value ? require(`@/assets/img/${button.activeIcon}`) : require(`@/assets/img/${button.inactiveIcon}`)" style="max-width:20px" class="mr-2" /> {{ button.label }}
                            </div>
                        </CCol>
                        <CCol sm="12" md="4" lg="8" class="text-right p-2">
                          <CButton class="btn-border-blue font-color-0B63F6" @click="genHoliday()"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1"/>Generate Holiday</CButton>
                          <CButton class="btn-border-blue font-color-0B63F6 ml-2" @click="addHoliday()"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1"/>Add Holiday</CButton>
                          <CButton class="btn-border-blue font-color-0B63F6 ml-2" @click="addEvent()"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1"/>Add Event</CButton>
                        </CCol>
    
                    </CRow>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div v-if="activeButton === 'team'">
                        <CRow class="m-2">
                            <CCol sm="12" md="4" lg="4" class="text-center p-2">
                                <CRow>
                                    <CCol sm="12" md="4" lg="6" v-for="button in buttonsTeam" :key="button.value">
                                    <div :class="{'blue-background': activeButtonTeam === button.value, 'blue-text': activeButtonTeam !== button.value}" @click="setActiveButtonTeam(button.value)" class="p-2">
                                       {{ button.label }}
                                    </div>
                                </CCol>

                                </CRow>
                                
                                <CCol sm="12">
                                    <!-- Only one condition should be true at a time -->
                                    <div v-if="activeButtonTeam === 'holiday'">
                                        <div class="text-left mt-3">
                                            <p class="custom-14px-500 font-color-98A2B3">25 Dec 2024</p>
                                            <p class="custom-14px-500 font-color-171717">
                                                Christmas Day
                                            </p>
                                            <hr />
                                            <p class="custom-14px-500 font-color-98A2B3">01 Nov 2024</p>
                                            <p class="custom-14px-500 font-color-171717">
                                                Birthday of the Sultan of Perak (Perak)
                                            </p>
                                            <hr />
                                            <p class="custom-14px-500 font-color-98A2B3">31 Oct2024</p>
                                            <p class="custom-14px-500 font-color-171717">
                                                Diwali/Deepavali (regional holiday)
                                            </p>
                                            <hr />
                                            <p class="custom-14px-500 font-color-98A2B3">17 Sept 2024</p>
                                            <p class="custom-14px-500 font-color-171717">
                                                Day off for Malaysia Day
                                            </p>
                                            <hr />
                                            <p class="custom-14px-500 font-color-98A2B3">16 Sept 2024</p>
                                            <p class="custom-14px-500 font-color-171717">
                                                The Prophet Muhammad's Birthday
                                            </p>
                                            <hr />
                                        </div>
                                       
                                    </div>
                                    <div v-if="activeButtonTeam === 'event'">
                                        <p class="custom-14px-500 font-color-98A2B3"></p>
                                    </div>
                                </CCol>
                            </CCol>
                            <CCol sm="12" md="8" lg="8">
                                <CRow class="m-2">
                                    <vue-cal :events="events" @day-click="onDayClick" class="font-color-171717" active-view="month" :disable-views="['years', 'year', 'week', 'day']" />
                                </CRow>
                            </CCol>
                        </CRow>
                    </div>
    
    
                    <div v-if="activeButton === 'shift'">
                        <CCard>
            <div class="table-container font-color-171717">
              <table>
                <!-- Table Header -->
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th v-for="day in weekDates" :key="'header-' + day">{{ day }}</th>
                  </tr>
                </thead>
  
                <!-- Table Body -->
                  <!-- Iterate over departments -->
                  <tbody v-for="dept in departments" :key="'dept-' + dept.id">
                    <!-- Department Header Row with Toggle -->
                    <tr>
                      <td :colspan="weekDates.length + 1" class="department-row">
                        <img
                          :src="visibleDepartments[dept.name] ? require('@/assets/img/minus-square.png') : require('@/assets/img/Plus2.png')"
                          alt="Toggle Icon"
                          @click="toggleDepartment(dept.name)"
                          style="width:20px"
                        />
                        {{ dept.name }}
                      </td>
                    </tr>
  
                    <!-- Iterate over employees for the current department -->
                    <template v-if="visibleDepartments[dept.name]">
                      <tr v-for="emp in employees[dept.name]" :key="'emp-' + emp">
                        <!-- Employee Rows for Current Department -->
                        <td>{{ emp }}</td>
                        <td v-for="day in weekDates" :key="'day-' + day">
                          <select v-model="statusOptions[dept.name][emp]" @change="submitSchedule" class="custom-select-grey">
                            <option value="default">Default Shift</option>
                            <option value="night">Night Shift</option>
                            <option value="leave">On Leave</option>
                          </select>
                        </td>
                      </tr>
                    </template>
                </tbody>
              </table>
            </div>
          </CCard>
                    </div>
    
    
                </CCard>
            </CCol>
    
        </CCol>

        

        <div v-if="GenHoliday" class="popup-all backdrop-all">
          <div class="popup-all2">
            <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Generate Holiday</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupGenHoliday" /></CCol>
                </CRow>
            <CCol sm="12" md="4" lg="2" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="12"><span>filter</span>
                                        <select v-model="perPage" id="entries" class="form-control">
                                                            <option :value="10">10</option>
                                                            <option :value="25">25</option>
                                                            <option :value="50">50</option>
                                                            <option :value="100">100</option>
                                                        </select>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
    
                        <v-client-table :data="allTableData" :columns="columns" :options="options" class="custom-table" v-if="allTableData.length > 0">
                            <template v-slot:No="{ row }">
                                                                                  <label class="custom-12px-500">{{ row.No }}</label>
                            </template>

                            <template v-slot:Title="{ row }">
                                <label class="custom-12px-500">{{ row.Title }}</label>
                            </template>

                            <template v-slot:Status="{ row }">
                                <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Status }}</label>
                            </template>

                            <template v-slot:Announcer="{ row }">
                                <label class="custom-12px-500">{{ row.Status }}</label>
                            </template>

                            <template v-slot:Created Date="{ row }">
                                <label class="custom-12px-500">{{ row.CreatedDate }}</label>
                            </template>

                            <template v-slot:Updated Date="{ row }">
                                <label class="custom-12px-500">{{ row.UpdatedDate }}</label>
                            </template>

                            <template v-slot:ImporttoCalendar="{ row }">
                                <div class="d-flex"> 
                                  <CSwitch class="mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>                                         
                                </div>
                            </template>
                            <template v-slot:SetasPublicHoliday="{ row }">
                                <div class="d-flex"> 
                                  <CSwitch class="mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>                                         
                                </div>
                            </template>
                                          </v-client-table>
                                          <div v-else class="no-data-message text-center" style="margin:10%">
                                  <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                                  <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                  <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                </div>
                                <br />
                                <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitCompany">
                                Generate</CButton>
                        </div>
                        <br />
            </div>
        </div>
          <div v-if="AddEvent" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Create New Event</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddEvent" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Title</h3>
                                        <CInput type="text" v-model="FullName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Description</h3>
                                        <CTextarea type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Date Start</h3>
                                        <CInput type="date" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Date End</h3>
                                        <CInput type="date" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Time</h3>
                                        <CInput type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Select Employee</h3>
                                        <CInput type="text" v-model="ShortName" />
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitCompany">
                                Submit</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="AddHoliday" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Create New Holiday</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddHoliday" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Description</h3>
                                        <CTextarea type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Date</h3>
                                        <CInput type="date" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="12">
                                      <CRow class="ml-1">
                                        <h3 class="custom-14px-500 font-color-171717">Public Holiday</h3>
                                        <CSwitch class="ml-3 float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                        </CRow>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitCompany">
                                Submit</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
                        
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import { CTextarea } from "@coreui/vue";


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },
    created() {
      this.initializeOptions();
    },

    data() {
        return {
            activeButton: 'team', // Default active button
            buttons: [
                { value: 'team', label: 'Team Calendar', activeIcon: 'calendar-white.png', inactiveIcon: 'calendar4.png' },
                { value: 'shift', label: 'Shift Calendar', activeIcon: 'shift-white.png', inactiveIcon: 'shift-black.png' },
            ],
            activeButtonTeam: 'holiday', // Default active button
            buttonsTeam: [
                { value: 'holiday', label: 'Holiday', activeIconTeam: 'calendar-white.png', inactiveIconTeam: 'calendar4.png' },
                { value: 'event', label: 'Event', activeIconTeam: 'shift-white.png', inactiveIconTeam: 'shift-black.png' },
            ],
            leaveOptions: [{
                    id: 1,
                    name: 'Annual Leave'
                },
                {
                    id: 2,
                    name: 'Emergency Leave'
                },
                {
                    id: 3,
                    name: 'Maternity Leave'
                },
                {
                    id: 3,
                    name: 'Paternity Leave'
                },
            ],
            "events": [{
                    "id": 1,
                    "start": "2024-08-10T10:00:00",
                    "end": "2024-08-10T11:00:00",
                    "title": "Event Title",
                    "description": "Event Description"
                },
                // More events
            ],
            startDate: new Date(),
            //shift
            weekDates: this.getWeekDates(),
            departments: [
            { id: 'logistic', name: 'Logistic' },
            { id: 'hr', name: 'HR' },
            { id: 'marketing', name: 'Marketing' }
            ],
            employees: {
            Logistic: ['John Doe', 'Jane Smith'],
            HR: ['Alice Johnson', 'Bob Brown'],
            Marketing: ['Elline', 'Adam'],
            },
            shifts: ['Morning', 'Afternoon', 'Night'],
            shiftOptions: {
            Logistic: {},
            HR: {},
            Marketing: {}
            },
            statusOptions: {
            Logistic: {},
            HR: {},
            Marketing: {}
            },
            visibleDepartments: {},
            GenHoliday : false,
            AddHoliday : false,
            AddEvent : false,
            allTableData: [
                { No: 1, Name: 'Taipusam', 'Date': '14 May 2024'},
                { No: 2, Name: 'Wesak','Date': '14 May 2024'},
                { No: 3, Name: 'Raya Haji', 'Date': '14 May 2024'}
            ],
            options: {
                perPage: 5,
                pagination: false,
                searchable: false,
                filterable: false,
            },
            columns: [
                'No',
                'Name',
                'Date',
                'ImporttoCalendar',
                'SetasPublicHoliday',
            ],

        }
    },
    async mounted() {
       
            try {
                const isAuth = await this.UserAuth();
                if (isAuth) {

                } else {
                    this.GoToPage();
                    this.$nextTick(() => {
          this.setCalendarView();
        });
                }
            } catch (error) {
                this.GoToPage();
                console.error("Error during authentication:", error);
                // Handle the error here
            }

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        setActiveButtonTeam(buttonValue) {
            this.activeButtonTeam = buttonValue;
        },
        onDayClick(date) {
            console.log('Date clicked:', date);
            // Handle day click event
        },
        setCalendarView() {
            const vueCal = this.$refs.vueCal;
            if (vueCal) {
                vueCal.setView(this.defaultView); // Set the calendar view to month
            }
        },
        getWeekDates() {
        const today = new Date();
        const startOfWeek = today.getDate() - today.getDay() + 1; // Adjust to start from Monday
        const weekDates = [];
        const daysOfWeek = ['M', 'T', 'W', 'T', 'F'];
  
        for (let i = 0; i < 5; i++) { // Only add 5 days for Monday to Friday
          const date = new Date(today.setDate(startOfWeek + i));
          const dayOfMonth = date.getDate();
          const dayOfWeek = daysOfWeek[i];
          weekDates.push(`${dayOfMonth} ${dayOfWeek}`);
        }
  
        return weekDates;
      },
      initializeOptions() {
        this.departments.forEach(dept => {
          // Initialize visibility for each department
          this.$set(this.visibleDepartments, dept.name, true);
          this.employees[dept.name].forEach(emp => {
            if (!this.shiftOptions[dept.name][emp]) {
              this.$set(this.shiftOptions[dept.name], emp, 'default');
            }
            if (!this.statusOptions[dept.name][emp]) {
              this.$set(this.statusOptions[dept.name], emp, 'default');
            }
          });
        });
      },
      submitSchedule() {
        console.log('Submitted Schedule:', {
          shiftOptions: this.shiftOptions,
          statusOptions: this.statusOptions,
        });
        // Logic to save the schedule data to your server
      },
      toggleDepartment(departmentName) {
        this.visibleDepartments[departmentName] = !this.visibleDepartments[departmentName];
      },
      genHoliday() {
            this.GenHoliday = true;
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            this.GenHoliday = false;
        },
        closePopupGenHoliday() {
            this.GenHoliday = false;
        },

        addHoliday() {
            this.AddHoliday = true;
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            this.AddHoliday = false;
        },
        closePopupAddHoliday() {
            this.AddHoliday = false;
        },
        addEvent() {
            this.AddEvent = true;
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            this.AddEvent = false;
        },
        closePopupAddEvent() {
            this.AddEvent = false;
        },



    }

};
</script>

<style scoped>
.table-container {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  text-align: left;
  padding: 12px var(--Other-Gap-11, 24px);
}

.department-row {
  font-weight: bold;
  text-align: left;
  border-bottom: 1px rgba(11, 99, 246, 0.10);
  background: rgba(11, 99, 246, 0.10);
  height: 44px;
  padding: 12px var(--Other-Gap-11, 24px);
}

.custom-select-grey {
  background-color: #f0f0f0;
}

img {
  cursor: pointer;
  margin-right: 8px;
}
</style>
